export default __webpack_public_path__ + "static/media/M1-male-01_mos_JTAN.6fe7947d.wav";